import React from 'react';
import Head from 'next/head';
import parse, { Element } from 'html-react-parser';
import { gql } from '@apollo/client';

import { useRouter } from 'next/router';
import Layout from '../../components/layout';
import Title from '../../components/title';
import IframeWrapper from '../../components/iframe-wrapper';
import { H1 } from '../../components/atoms/typography';
import {
  getYoastHeadSEO,
  isEmbeddedVideo,
  isLinkToArticle,
  isMatchingLink
} from '../../lib/utils';
import { CMS_HOSTNAME } from '../../lib/constants';
import { client, getPageByURI } from '../../apollo-client';

const Partners = ({ page }) => {
  const getPostContent = () => {
    let post_content = page.content.toString();

    post_content = post_content.replace(
      /\r\n<h3>/g,
      '<p style="margin:0;padding:0;">&nbsp;</p><h3>'
    );
    post_content = post_content.replace(/\[\/?et_pb.*?\]/g, '');

    return post_content.replace(
      /\r\n<ul>/g,
      '<p style="margin:0;padding:0;">&nbsp;</p><ul>'
    );
  };

  const router = useRouter();
  const pathname = router.pathname;
  const yoastHead = getYoastHeadSEO(page?.seo?.fullHead, pathname);

  return (
    <>
      <Head>{yoastHead}</Head>

      <Title>{'Our Partners'}</Title>

      <Layout>
        <div className="article">
          <div className="relative bg-white pt-8 pb-20 px-4 sm:px-6 lg:pb-10 lg:px-8">
            <div className="relative max-w-7xl mx-auto pb-14">
              <article className="article">
                <div className="text-center">
                  <H1>{'Our Partners'}</H1>
                  {/* <small className="block text-xs text-center text-indigo-600 font-semibold tracking-wide uppercase  mb-8">{moment(post_item.date).format('ddd DD MMM YYYY')}</small> */}
                </div>
                <div className="mt-4 text-base text-gray-500">
                  {parse(getPostContent(), {
                    replace: (domNode: Element) => {
                      if (
                        domNode.attribs &&
                        domNode.attribs.class &&
                        domNode.attribs.class === 'epyt-video-wrapper'
                      ) {
                        // fixes double wrapping of iframe
                        domNode.attribs.class = '';

                        return { domNode };
                      }

                      if (isEmbeddedVideo(domNode)) {
                        return (
                          <IframeWrapper
                            id={domNode.attribs.id}
                            name={domNode.attribs.name}
                            src={domNode.attribs.src}
                            title={domNode.attribs.title}
                          />
                        );
                      }

                      if (isMatchingLink(domNode, '/dropusaline')) {
                        domNode.attribs.href = `${process.env.NEXT_PUBLIC_HOSTNAME}/contact`;

                        return { domNode };
                      }

                      if (isLinkToArticle(domNode)) {
                        domNode.attribs.href = domNode.attribs.href.replace(
                          CMS_HOSTNAME,
                          `${process.env.NEXT_PUBLIC_HOSTNAME}/articles`
                        );

                        return { domNode };
                      }
                    }
                  })}
                </div>
              </article>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export const getStaticProps = async () => {
  const pageQuery = await client.query({
    query: gql`
      ${getPageByURI('/our-partners/')}
    `
  });

  const page = pageQuery.data.pageBy;

  return {
    props: { page }
  };
};

export default Partners;
